export const enum TrackingId {
  devApp = 'G-Q02M957N6S',
  prodApp = 'G-7X1DXZG51H',
}
